import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading1 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import { getPublicPath } from 'utils/paths';
import {
  StyledCardsBoxContainer,
  StyledContainer,
  StyledHero,
  StyledIrregularBox,
  StyledTitle,
  StyledWarning,
  StyledWrapper
} from './JuniorsHero.styled';
import { WikiCard } from './WikiCard';

const JuniorsHero: React.FC = () => {
  const { t } = useI18n('helping-companies');
  const { locale } = useRouter();

  return (
    <StyledHero>
      <StyledWrapper>
        <StyledContainer>
          <StyledTitle>
            <Heading1>{t('helping-companies.hero.title')}</Heading1>
            <HtmlTrans
              ns="helping-companies"
              i18nKey="helping-companies.hero.desc"
            />
            {locale === 'en' && (
              <StyledWarning>
                <FontAwesomeIcon icon={faLanguage} />
                <span>{t('helping-companies.hero.warning')}</span>
              </StyledWarning>
            )}
          </StyledTitle>
          <StyledCardsBoxContainer>
            <StyledIrregularBox
              $src={getPublicPath(
                `/images/helpingCompanies/irregular-box-violet.svg`
              )}
              $width="90%"
            >
              <WikiCard
                iconPath={getPublicPath(`/images/helpingCompanies/icon-1.svg`)}
                title={t('helping-companies.hero.card-1-title')}
                subtitle={t('helping-companies.hero.card-1-subtitle')}
              />
              <WikiCard
                iconPath={getPublicPath(`/images/helpingCompanies/icon-2.svg`)}
                title={t('helping-companies.hero.card-2-title')}
                subtitle={t('helping-companies.hero.card-2-subtitle')}
              />
              <WikiCard
                iconPath={getPublicPath(`/images/helpingCompanies/icon-3.svg`)}
                title={t('helping-companies.hero.card-3-title')}
                subtitle={t('helping-companies.hero.card-3-subtitle')}
              />
            </StyledIrregularBox>
          </StyledCardsBoxContainer>
        </StyledContainer>
      </StyledWrapper>
    </StyledHero>
  );
};

export default JuniorsHero;
